import React, { useState } from 'react';

import { saveCommunitiesEmailNotificationRecipients } from 'apis/CommunityAPI';
import { useRootContext } from 'components/layout/RootContext';
import SettingsPage from 'components/Settings/SettingsPage';
import { CommunityPreferenceNotification, CommunityPreferenceType } from 'types/communities';

import CommunitySettingLabel from '../../CommunitySettingLabel';
import {
  COMMUNITY_LABEL_COLOR,
  COMMUNITY_SETTINGS_PAGE_TYPE,
  EMAIL_NOTIFICATION_TYPE,
  SALES_BATTLECARD_DIGEST,
} from '../../constants';
import EmailNotificationsRecipientsModal from '../EmailNotificationsRecipientsModal';

const getItemStatusComponent = (item: CommunityPreferenceType) => {
  const { statusElements } = SALES_BATTLECARD_DIGEST;

  switch (item.preferences?.sales_battlecard_digest_notifications) {
    case true:
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
          <CommunitySettingLabel color={COMMUNITY_LABEL_COLOR.POSITIVE}>
            {statusElements.ON.label}
          </CommunitySettingLabel>
          <span style={{ color: 'var(--gray-dark)', fontSize: 12 }}>
            {item.receiving_notification_users_no}/{item.total_users_no} users receiving
          </span>
        </div>
      );
    case false:
    default:
      return (
        <CommunitySettingLabel color={COMMUNITY_LABEL_COLOR.NEUTRAL}>{statusElements.OFF.label}</CommunitySettingLabel>
      );
  }
};

const SalesBattlecardDigest = () => {
  const { showMessage } = useRootContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [communitiesToModify, setCommunitiesToModify] = useState<CommunityPreferenceType[]>([]);
  const [refetchCommunities, setRefetchCommunities] = useState<() => void | undefined>();
  const [clearSelection, setClearSelection] = useState<() => void | undefined>();

  const showCommunitiesEditModal = (items: any[]) => {
    setCommunitiesToModify(items);
    setIsModalOpen(true);
  };

  const savePreferenceRecipients = (newStatus: number, preferenceNotifications: CommunityPreferenceNotification[]) => {
    setLoading(true);

    const payload = {
      communities: preferenceNotifications,
      email_notifications_enabled: newStatus,
    };

    saveCommunitiesEmailNotificationRecipients(EMAIL_NOTIFICATION_TYPE.SALES_BATTLECARD_DIGEST, payload)
      .then(() => {
        showMessage('success', 'All selected communities updated successfully');
        if (refetchCommunities) refetchCommunities();
        if (clearSelection) clearSelection();
      })
      .catch(() => {
        showMessage('error', 'Failed to update one or more communities!');
      })
      .finally(() => {
        setLoading(false);
        setIsModalOpen(false);
      });
  };

  return (
    <>
      <SettingsPage
        filterOptions={Object.values(SALES_BATTLECARD_DIGEST.statusElements)}
        getItemStatusComponent={getItemStatusComponent}
        showCommunitiesEditModal={showCommunitiesEditModal}
        settingsPageType={COMMUNITY_SETTINGS_PAGE_TYPE.SALES_BATTLECARD_DIGEST}
        setRefetchCommunities={setRefetchCommunities}
        setClearSelection={setClearSelection}
        filterField={SALES_BATTLECARD_DIGEST.field}
        notificationType={EMAIL_NOTIFICATION_TYPE.SALES_BATTLECARD_DIGEST}
      />
      <EmailNotificationsRecipientsModal
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        loading={loading}
        title={SALES_BATTLECARD_DIGEST.title}
        communitiesToModify={communitiesToModify}
        onSave={savePreferenceRecipients}
        settingsPageType={COMMUNITY_SETTINGS_PAGE_TYPE.SALES_BATTLECARD_DIGEST}
      />
    </>
  );
};

export default SalesBattlecardDigest;
